export default __webpack_public_path__ + "static/media/crazyapp.1cb46e5b.png";